// extracted by mini-css-extract-plugin
export default {"ForeCast":"ForeCast_ForeCast__0Yt1f","ForeCastWrapper":"ForeCast_ForeCastWrapper__EM6Zm"};